import { BaseViewStore } from 'core/stores';
import { action, observable } from "mobx";
import _ from 'lodash';

class FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalStore extends BaseViewStore {
	@observable accessor items;
	@observable accessor facilityOrderTemplates;
	constructor(rootStore, componentsProps) {
        super(rootStore);

        this.rootStore = rootStore;

        this.fetch([
			this.initialize(componentsProps)
		]);
    }

	@action.bound
	async initialize(componentsProps) {
		this.patient = componentsProps.modalParams.data.patient;
		var templates = _.orderBy(componentsProps.modalParams.data.facilityOrderTemplates, ['templateId'], ['asc']);
		this.facilityOrderTemplates = _.map(templates, i => { return { ...i, itemsVisibleInitial: false, itemsVisible: false }; })
		this.facilityOrderPatient = componentsProps.modalParams.data.facilityOrderPatient;
		this.dataComparison();
	}

	@action.bound
	dataComparison() {
		this.isPrimaryInsuranceDifferent = this.patient.primaryInsurance != (this.facilityOrderTemplates[0].facilityOrderTemplateInitial ? this.facilityOrderTemplates[0].facilityOrderTemplateInitial.primaryInsurance : null) || this.patient.primaryPolicyNo != (this.facilityOrderTemplates[0].facilityOrderTemplateInitial ? this.facilityOrderTemplates[0].facilityOrderTemplateInitial.primaryPolicyNo : null);
		this.isInactivePrimaryInsuranceDifferent = this.patient.inactiveMedicareNo != (this.facilityOrderTemplates[0].facilityOrderTemplateInitial ? this.facilityOrderTemplates[0].facilityOrderTemplateInitial.inactivePrimaryPolicyNo : null);
		this.isSecondaryInsuranceDifferent = this.patient.secondaryInsurance != (this.facilityOrderTemplates[0].facilityOrderTemplateInitial ? this.facilityOrderTemplates[0].facilityOrderTemplateInitial.secondaryInsurance : null) || this.patient.secondaryPolicyNo != (this.facilityOrderTemplates[0].facilityOrderTemplateInitial ? this.facilityOrderTemplates[0].facilityOrderTemplateInitial.secondaryPolicyNo : null);
		this.isInactiveSecondaryInsuranceDifferent = this.patient.inactiveMedicaidNo != (this.facilityOrderTemplates[0].facilityOrderTemplateInitial ? this.facilityOrderTemplates[0].facilityOrderTemplateInitial.inactiveSecondaryPolicyNo :  null);
		this.isEligibilityStatusDifferent = this.facilityOrderPatient && this.facilityOrderPatient.eligibilityStatusId != (this.facilityOrderPatient.facilityOrderPatientInitial ? this.facilityOrderPatient.facilityOrderPatientInitial.eligibilityStatusId : null);
	}

	@action.bound
	changeItemsVisibility(facilityOrderTemplate, isInitial) {
		if (isInitial) {
			facilityOrderTemplate.itemsVisibleInitial = !facilityOrderTemplate.itemsVisibleInitial;
		} else {
			facilityOrderTemplate.itemsVisible = !facilityOrderTemplate.itemsVisible;
		}
	}
}

export default FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalStore;
